import { render, staticRenderFns } from "./altaTratamiento.vue?vue&type=template&id=00a4da42&scoped=true"
import script from "./altaTratamiento.vue?vue&type=script&lang=js"
export * from "./altaTratamiento.vue?vue&type=script&lang=js"
import style0 from "./altaTratamiento.vue?vue&type=style&index=0&id=00a4da42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4da42",
  null
  
)

export default component.exports